import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const Faq = ({ items, idPrefix = "faq" }) => {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-[#1C2027] border border-[#1C2027] bg-[#10131A]" data-testid={`${idPrefix}-accordion`}>
      {items.map((f, i) => (
        <Reveal key={i} delay={i * 0.05} y={12}>
          <div>
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              data-testid={`${idPrefix}-question-${i}`}
              className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-200 hover:bg-white/[0.03] sm:px-7"
            >
              <span className="text-sm font-semibold text-white sm:text-base">{f.q}</span>
              <Plus className={`h-5 w-5 shrink-0 text-[#F5A800] transition-transform duration-300 ${open === i ? "rotate-45" : ""}`} />
            </button>
            <AnimatePresence initial={false}>
              {open === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p data-testid={`${idPrefix}-answer-${i}`} className="px-5 pb-6 text-sm leading-relaxed text-[#9BA1AB] sm:px-7">
                    {f.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </Reveal>
      ))}
    </div>
  );
};

export default Faq;
